import { getAddresses, addAddress, updateAddress, deleteAddress } from '@/mock/addresses';

export default {
  namespaced: true,
  state: {
    addresses: [],
    loading: false,
    error: null
  },
  getters: {
    userAddresses: (state) => state.addresses,
    defaultAddress: (state) => state.addresses.find(a => a.isDefault),
    isLoading: (state) => state.loading,
    error: (state) => state.error
  },
  mutations: {
    SET_ADDRESSES(state, addresses) {
      state.addresses = addresses;
    },
    ADD_ADDRESS(state, address) {
      state.addresses.push(address);
    },
    UPDATE_ADDRESS(state, updatedAddress) {
      const index = state.addresses.findIndex(a => a.id === updatedAddress.id);
      if (index !== -1) {
        state.addresses[index] = updatedAddress;
      }
    },
    DELETE_ADDRESS(state, addressId) {
      state.addresses = state.addresses.filter(a => a.id !== addressId);
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    }
  },
  actions: {
    async fetchAddresses({ commit, rootState }) {
      commit('SET_LOADING', true);
      try {
        const userId = rootState.auth.user?.id;
        const addresses = await getAddresses(userId);
        commit('SET_ADDRESSES', addresses);
      } catch (error) {
        commit('SET_ERROR', error.message);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async createAddress({ commit, rootState }, addressData) {
      commit('SET_LOADING', true);
      try {
        const address = await addAddress({
          ...addressData,
          userId: rootState.auth.user.id
        });
        commit('ADD_ADDRESS', address);
        return address;
      } catch (error) {
        commit('SET_ERROR', error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async editAddress({ commit }, { id, updates }) {
      commit('SET_LOADING', true);
      try {
        const updatedAddress = await updateAddress(id, updates);
        commit('UPDATE_ADDRESS', updatedAddress);
        return updatedAddress;
      } catch (error) {
        commit('SET_ERROR', error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async removeAddress({ commit }, id) {
      commit('SET_LOADING', true);
      try {
        await deleteAddress(id);
        commit('DELETE_ADDRESS', id);
      } catch (error) {
        commit('SET_ERROR', error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    }
  }
};